import { forwardRef, SelectHTMLAttributes } from 'react'

import './style.scss'
import { Loading } from '..'

interface InputProps extends SelectHTMLAttributes<HTMLSelectElement> {
  className?: string,
  sizes?: 'sm' | 'md' | 'lg' | 'xl' | '',
  color?: string,
  fullWidth?: boolean,
  disabled?: boolean,
  error?: boolean,
  version?: '2' | '3' | '4' | '4' ,
  loading?: boolean
}

type Ref = HTMLSelectElement;

const Select = forwardRef<Ref, InputProps>(({ children, className = '', sizes = '', color = '', fullWidth = false, disabled, error = false, version = '', loading = false, ...rest }, ref) => {
  return (
    <div className={`select d-inline-block ${version ? 'select--v' + version : ''} ${color ? 'select--' + color : ''} ${sizes ? 'select--' + sizes : ''} ${fullWidth ? 'w-full' : ''} ${disabled ? 'select--disabled' : ''} ${error ? 'select--error' : ''} ${className}`}>
      <select disabled={disabled} ref={ref} {...rest}>
        {children}
      </select>
      {loading && <Loading size="sm" align="center" overlay />}
    </div>
  )
})

export { Select }